import {
  useJsApiLoader,
  GoogleMap,
  DirectionsRenderer,
  Autocomplete,
} from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { showCustomAlert } from "../Signup/Toast";
import api from "../../../utils/api";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const defaultCenter = { lat: 40.748817, lng: -73.985428 }; // Default to New York

function GoogleMapsTracking({
  userAddress,
  restaurantAddress,
  setUserAddress,
  setOrderType,
  divStyles= 'relative my-8 w-[90%] mx-auto max-w-full',
  withButton = true,
  inputStyles = 'w-full md:max-w-[90%] px-5 flex items-center justify-center lg:h-[71.63px] lg:text-[20px] text-[15.14px] md:text-[18px] sm:w-full md:h-[49.63px] h-[40px] sm:h-[40px] p-2 border border-gray-300 focus:outline-none focus:border-[#AF313D]'
}) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDDq_Z5B-HLaZH9Wsans0cbSSZ28y3GkEs",
    libraries: ["places"],
  });

  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState("");
  const [storeInfo, setStoreInfo] = useState([])
  const [duration, setDuration] = useState("");
  const [responseHere, setResponse] = useState([]);
  const autocompleteRef = useRef(null);
  // console.log("======", responseHere)
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (isLoaded && userAddress && restaurantAddress) {
      calculateRoute();
    }
  }, [isLoaded, userAddress, restaurantAddress]);
  const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))


  const getLocation =async()=>{
    const response = await api.get(`/restaurant/${RestaurantSavedId}`);
    console.log("🚀 ~ getLocation ~ response", response)
    setStoreInfo(response.data.data)
  }
  useEffect(() => {
    getLocation()
  }, [])
  async function calculateRoute() {
    try {
      const directionsService = new window.google.maps.DirectionsService();
      const destinationAddress =  storeInfo?.address;

      if (!destinationAddress) {
        console.warn("No valid restaurant address found.");
        return;
      }

      const results = await directionsService.route({
        origin: userAddress,
        destination: destinationAddress,
        travelMode: window.google.maps.TravelMode.DRIVING,
      });

      if (results?.routes.length > 0) {
        setDirectionsResponse(results);
        setDistance(results.routes[0].legs[0].distance.text);
        setDuration(results.routes[0].legs[0].duration.text);
      }
    } catch (error) {
      console.error("Error fetching directions:", error);
    }
  }

  const handlePlaceSelect = async () => {
    const place = autocompleteRef.current.getPlace();
    let newAddress = place?.formatted_address || user?.addresses?.find(addr => addr?.primary)?.address || "";

    if (newAddress) {
      try {
        const payload = {
          userAddress: newAddress,
          restaurantAddress: restaurantAddress || storeInfo?.address,
        };

        const response = await api.post(`/order/checkDeliveryDistance`, payload);
        setResponse(response);
        Cookies.set("userAddress", response?.data?.originAddress);
        Cookies.set("restaurantAddress", response?.data?.destinationAddress);
        setUserAddress(response?.data?.originAddress)
      } catch (error) {
        console.log(error);
        if (error) {
          Swal.fire({
            title: "We Accept delivery only within 5 miles!",
            html: `<p style="color: #555;">${error?.response?.data?.message || "message hi ni he "}</p>`,
            icon: "error",
            showCancelButton: true,
            confirmButtonText: "Choose Pickup",
            cancelButtonText: "Retry",
            confirmButtonColor: "#af313d",
            background: "#ffffff",
          }).then((result) => {
            if (result.isConfirmed) {
              setOrderType();
            }
          });
        }
      }
    } else {
      showCustomAlert({
        title: "Location not selected!",
        html: '<p style="color: #555;">Please enter your address before submitting.</p>',
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#af313d",
        background: "#ffffff",
      });
    }
};

  const handleLocationClick = async () => {
    if (autocompleteRef.current ) {
      handlePlaceSelect();
    } else {
      showCustomAlert({
        title: "Location not selected!",
        html: '<p style="color: #555;">Please enter your address before submitting.</p>',
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#af313d",
        background: "#ffffff",
      });
    }
  };

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading maps...</p>;

  return (
    <div className={`${divStyles}`}>
      <div className="flex flex-col w-[100%] mx-auto max-w-full justify-center items-center">
        <Autocomplete
          className="w-full justify-center items-center mx-auto flex"
          onLoad={(ref) => (autocompleteRef.current = ref)}
          onPlaceChanged={!withButton ? handlePlaceSelect : undefined}
        >
          <input
            type="text"
            readOnly
            onFocus={(e) => e.target.removeAttribute("readOnly")}
            autoComplete="off"
            defaultValue={user?.addresses?.find(addr => addr?.primary)?.address || ""}

            placeholder="Enter your address"
            className={`${inputStyles}`}
          />
        </Autocomplete>

        {responseHere && <p>{responseHere?.data?.message}</p>}

        {withButton && (
          <button
            onClick={handleLocationClick}
            className="flex items-center justify-center py-2  md:max-w-[90%] shadow-md mt-2 font-baloo font-semibold rounded-md md:text-[18.18px] mb-3 bg-[#AF313D] text-white px-3"
          >
            confirm location
          </button>
        )}
      </div>

      {directionsResponse ? (
        <div className="relative h-[300px] bg-gray-200 rounded-md flex items-center justify-center mt-4">
          <div className="absolute left-0 top-0 h-full w-full">
            <GoogleMap
              center={defaultCenter}
              zoom={13}
              mapContainerStyle={{ width: "100%", height: "100%" }}
              options={{
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
              }}
            >
              <DirectionsRenderer directions={directionsResponse} />
            </GoogleMap>
          </div>
          <div className="absolute bottom-4 bg-white p-4 rounded-lg shadow-md">
            <p><strong>Distance:</strong> {distance}</p>
            <p><strong>Duration:</strong> {duration}</p>
          </div>
        </div>
      ) : (
        <p className="text-center mt-4 text-gray-600"></p>
      )}
    </div>
  );
}

export default GoogleMapsTracking;
